
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useThrottle.html",
      function () {
        return require("private-next-pages/Hooks/useThrottle.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useThrottle.html"])
      });
    }
  